export default {
  lang: '中文',
  zhyun: '智 会 云 科 技',
  navName1: '网站首页',
  navName2: '关于我们',
  navName3: '新闻资讯',
  navName4: '产品展示',
  navName5: '客户案例',
  navName6: '联系我们',
  navName7: '技术文档',
  servicePhone: '服务热线：',
  serviceName: '无纸化系统研发制造商',
  footerContactTitle: '联系我们',
  footerPhoneLabel: '电话：',
  footerEmailLabel: '邮箱：',
  footerAddressLabel: '地址：',
  footerAddressValue: '广东省广州市黄埔区南翔三路19号金地创智汇E栋902',
  footerFollowTitle: '关注我们',
  footerWebsiteLabel: '官方网站：',
  footerWechatLabel: '微信服务号：',
  footerWechatValue: '智会云GZZHYUN',
  footerWechatTitle: '微信服务号',
  footerCopyright: 'Copyright © 2018-2026 广州智会云科技有限公司 All rights reserved.',
  websiteTitle: '广州智会云官网',
  home: {
    customerFirst: '客户至上',
    professional: '专业用心',
    achievement: '成就智会',
    contactUs: '联 系 我 们',
    companyInformation: '公司资讯',
    companyProfile: '公司简介',
    aboutZhyun: '关于“智会云”',
    companyDescription: '广州智会云科技有限公司，是经国家认定的高新技术企业，是一家极具活力和创造力的公司，拥有专业，创新的顶尖研发团队，是一家专门针对会议各系统，具备独立研发和生产能力的高新科技公司。本公司专注于无纸化会议系统、电子桌牌系统、数字会议、中控矩阵等产品的研发、生产及销售。以客户定制为特色，为客户打造快捷、高效、个性化的整体会议环境。',
    companyNews: '公司新闻',
    projectCases: '项目案例',
    productCenter: '产品中心',
    enterpriseHonor: '企业荣誉'
  },
  aboutUs: {
    companyIntroduction: '公司介绍',
    industry: '行业领域',
    certification: '公司资质'
  },
  news: {
    newsInformation: '新闻资讯'
  },
  products: {
    productCenter: '产品中心',
    viewMore: '查看更多',
    videoShowcase: '视频展示',
    videos: '视频展示',
    noData: '暂无视频数据'
  },
  case: {
    case: '客户案例'
  },
  technical: {
    technical: '技术文档',
    download: '立即下载'
  },
  contactUs: {
    contactUs: '联系我们',
    contactInformation: '联系方式',
    businessPhone: '商务电话：',
    contactPerson: '联系人：',
    contactPhone: '电话：',
    wechat: '微信：',
    contactAddress: '联系地址',
    leaveMessage: '在线留言',
    leaveMessageDesc: '欢迎填写您的需求或问题，我们会尽快与您联系。',
    messageCompany: '公司',
    messageCompanyPlaceholder: '请输入公司名称',
    messageName: '姓名',
    messageNamePlaceholder: '请输入您的姓名',
    messagePhone: '手机号',
    messagePhonePlaceholder: '请输入您的手机号',
    messageWechat: '微信号',
    messageWechatPlaceholder: '请输入您的微信号（选填）',
    messageWhatsappPlaceholder: '请输入您的WhatsApp号码（选填）',
    messageEmail: '邮箱',
    messageEmailPlaceholder: '请输入您的邮箱（选填）',
    messageContent: '留言内容',
    messageContentPlaceholder: '请输入您的需求、问题或合作意向',
    messageSubmit: '提交留言',
    messagePhoneInvalid: '请输入正确的手机号',
    messageEmailInvalid: '请输入正确的邮箱地址',
    messageContentRequired: '请输入留言内容',
    messageSubmitSuccess: '留言提交成功，我们会尽快与您联系',
    address: '地址：中国广东省广州市黄埔区南翔三路19号金地创智汇E栋902',
    factoryAddress: '工厂地址：中国广东省广州市黄埔区南翔三路19号金地创智汇E栋902',
    zhyunName: '广州智会云科技有限公司',
    zhyunAddress: 'E栋902',

    onlineMessage: '在线留言',
    formCompany: '公司（必填）',
    formName: '姓名（必填）',
    formPhone: '手机号（必填）',
    formEmail: '邮箱（选填）',
    formWechat: '微信（选填）',
    formWhatsapp: 'WhatsApp（选填）',
    formContent: '请输入您的问题...',
    formClose: '关闭',
    formSend: '发送',
    firstReplyContent: '您好！很高兴为您服务。为了我们的销售团队能尽快与您联系并提供详细信息，请问您方便提供WhatsApp号码或电话吗？'
  }
}
